import { ThemeUICSSObject, spacing } from '@apia/theme';
import { entityAndProcessData } from './entityData';
/* IMPORT HERE */

const processData: ThemeUICSSObject = {
  ...entityAndProcessData,

  '.ProcessDataDocuments': {
    '.processData__actions': {
      p: spacing(3),
    },
  },
  /* PREPEND HERE */
};

export default processData;
